<template>
  <div class="data-table-filter">
    <q-table
      class="data-table-filter__table scroll"
      dense
      :data="rows"
      no-data-label="I didn't find anything for you"
      no-results-label="The filter didn't uncover any results"
      :columns="columns"
      :pagination.sync="pagination"
      hide-pagination
      virtual-scroll
      flat
      style="height: 300px"
      :loading="visible"
      @row-click="getDataTableRow"
      :visible-columns="visibleColumns"
    >
      <template v-slot:loading>
        <q-inner-loading showing color="secondary" />
      </template>
      <template v-slot:header-cell="props">
        <q-th :props="props">
          {{ props.col.label }}
        </q-th>
      </template>
    </q-table>

    <div class="data-table-filter__filter">
      <div class="data-table-filter__filter--row">
        <q-btn
          class="data-table-filter__filter--button"
          color="secondary"
          label="Non-Depositors"
          no-caps
          size="12px"
          outline
          rounded
          @click="getfilterButton('Non-Depositors')"
        />
        <q-btn
          class="data-table-filter__filter--button"
          color="secondary"
          label="Big Depositors"
          no-caps
          size="12px"
          outline
          rounded
          @click="getfilterButton('Big Depositors')"
        />
        <q-btn
          class="data-table-filter__filter--button"
          color="secondary"
          label="Free Cash Regs"
          no-caps
          size="12px"
          outline
          rounded
          @click="getfilterButton('Free Cash Regs')"
        />
        <q-btn
          class="data-table-filter__filter--button"
          color="secondary"
          label="Non-Bonused"
          no-caps
          size="12px"
          outline
          rounded
          @click="getfilterButton('Non-Bonused')"
        />
      </div>
      <div class="data-table-filter__filter--row">
        <q-btn
          class="data-table-filter__filter--button"
          color="secondary"
          label="Big Winners"
          no-caps
          size="12px"
          outline
          rounded
          @click="getfilterButton('Big Winners')"
        />
        <q-btn
          class="data-table-filter__filter--button"
          color="secondary"
          label="Big Contributors"
          no-caps
          size="12px"
          outline
          rounded
          @click="getfilterButton('Big Contributors')"
        />
        <q-btn
          class="data-table-filter__filter--button"
          color="secondary"
          label="Bad Experience"
          no-caps
          size="12px"
          outline
          rounded
          @click="getfilterButton('Bad Experience')"
        />
        <q-btn
          class="data-table-filter__filter--button"
          color="secondary"
          label="Known Users"
          no-caps
          size="12px"
          outline
          rounded
          @click="getfilterButton('Known Users')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { count } from "@/utils/formatNumbers";
import { formatPercentageWithBrackets } from "@/utils/formatPercentage";
import { formatPropertyLabel } from "@/utils/formatText";
import { formatCurrency } from "@/utils/formatCurrency"
export default {
  props: {
    dataset: String,
    timer: Number,
    filter: Object,
  },

  data() {
    return {
      visibleColumns: [
        "Channel",
        "Registrations",
        "New_Registrations",
        "FTDs",
        "Average_FTD_Value",
      ],
      pagination: {
        page: 1,
        rowsPerPage: 10,
      },
      columns: [],
      keys: [],
      rows: [],
      errors: [],
      interval: null,
      dataRefresh: this.$props.timer,
      visible: true,
    };
  },

  methods: {
    async fetchData(siteId, networkId, operatorId) {
      // Dataset name is the store procedure name used to return the results.
      const payload = {
        filterOptions: {
          siteIds: siteId ? [siteId] : [],
          networkId,
          operatorId,
        },
        report: "live-acquisition",
        dataset: this.$props.dataset.replace(/ /g, ""),
      };

      await this.$store
        .dispatch("fetchData", payload)
        .then((response) => {
          if (response.data[0] !== undefined) {
            const keys = Object.keys(response.data[0]);

            this.columns = keys.map((key) => ({
              name: key,
              label: formatPropertyLabel(key),
              field: key,
              sortable: true,
              align: "left",
              format: (value, index) => {
                if (key === "Channel" && value !== null) {
                  return value;
                } else if (key === "New_Registrations" && value !== null) {
                  return (
                    count(index.New_Registrations) +
                    " " +
                    formatPercentageWithBrackets(
                      index.New_Registrations_Percentage
                    )
                  );
                } else if (key === "FTDs" && value !== null) {
                  return (
                    count(index.FTDs) +
                    " " +
                    formatPercentageWithBrackets(
                      index.FTD_Percentage
                    )
                  );
                } else if (key === "Average_FTD_Value" && value !== null) {
                  return formatCurrency(value);
                } else if (value !== null) {
                  return count(value);
                } else {
                  return `---`;
                }
              },
            }));
          }
          this.rows = response.data;
          this.visible = false;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // Filter Actions
    getDataTableRow(evt, row) {
      let rowItem = row.Channel;
      this.$store.commit("SET_LIVE_ACQUISITION_FILTER_CHANNEL", {
        channel: rowItem,
      });
    },
    getfilterButton(item) {
      let filterSelected = item;
      this.$store.commit("SET_LIVE_ACQUISITION_FILTER_BUTTON", {
        button: filterSelected,
      });
    },
  },
  watch: {
    filter: function(filterOption) {
      this.fetchData(
        filterOption.siteId,
        filterOption.networkId,
        filterOption.operatorId
      );
      this.visible = true;

      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.fetchData(
          filterOption.siteId,
          filterOption.networkId,
          filterOption.operatorId
        );
      }, 180000);
    },
  },
  mounted() {
    this.fetchData(
      this.$store.state.siteFilter.id,
      this.$store.state.networkFilter.id,
      this.$store.state.selectedOperator.id
    );
    this.visible = true;
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.fetchData(
        this.$store.state.siteFilter.id,
        this.$store.state.networkFilter.id,
        this.$store.state.selectedOperator.id
      );
    }, 180000);
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.rows.length / this.pagination.rowsPerPage);
    },
  },
  beforeDestroy: function() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss">
.data-table-filter {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  &__pagination {
    padding: 13px 10px;
  }
  &__table {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    &--title {
      font-weight: 600;
      font-size: 14px;
      line-height: 14px;
    }
    .q-table__top {
      padding: 12px 15px;
      border-bottom: 0.5px solid #ececec;
    }
    .q-table__middle {
      .q-table {
        padding: 5px 10px 10px;
        thead {
          th {
            font-size: 11px;
            font-weight: 600;
            padding: 4px 2px;
            border-color: #ececec;
          }
        }
        tbody {
          tr {
            height: 25px;
            &:nth-child(even) {
              background: rgba(69, 142, 221, 0.05);
            }
            td {
              height: 25px;
              font-size: 11px;
              font-weight: 500;
              padding: 4px 4px;
              color: #747474;
              border-color: #ececec;
              max-width: 110px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
  &__filter {
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    height: 100px;
    width: 100%;
    background: #f6f9fd;
    padding: 10px;
    &--row {
      display: flex;
      justify-content: space-evenly;
      &:first-child {
        padding-bottom: 8px;
      }
    }
    &--button {
      width: 125px;
      margin: 4px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
// Dark Mode
.body {
  &--dark {
    .data-table-filter {
      &__table {
        .q-table__top {
          border-bottom: 0.5px solid #353535;
        }
        .q-table__middle {
          .q-table {
            thead {
              th {
                border-color: #353535 !important;
              }
            }
            tbody {
              tr {
                height: 25px;
                &:nth-child(even) {
                  background: #353535;
                }
                td {
                  color: #ffffff;
                  border-color: #353535 !important;
                }
              }
            }
          }
        }
      }
      &__filter {
        background: #04080e;
      }
    }
  }
}
</style>
